import { DiverPRCError } from "@/core/types/AxiosError"

export function getPRCErrorMessage(err: DiverPRCError): string {
  if (err.code === 4001) {
    return "User rejected the request"
  } else if (err.code === 4100) {
    return "Request method and/or account has not been authorized by the user"
  } else if (err.code === 4200) {
    return "Provider does not support the request method"
  } else if (err.code === 4900) {
    return "Provider is disconnected from all chains"
  } else if (err.code === 4901) {
    return "Provider is not connected to the chain requested"
  } else if (err.code === -32002) {
    return "Already request in DIVER wallet"
  } else {
    return `error: ${err.message}`
  }
}
